module.exports = __webpack_public_path__ + "static/media/Team.0a66e42f.jpg";